// *************************** Import CSS *************************** //

import '@styles/main.scss';
import "./ss2026-feature.css";

// *************************** Import Images *************************** //

// ** Gallery Images ** //
// import "/src/assets/spring-sessions-2026/aurelia-beginner-student.webp";
// import "/src/assets/spring-sessions-2026/returning-students-coding.webp";
// import "/src/assets/spring-sessions-2026/makayla-beginner-student.webp";
// import "/src/assets/spring-sessions-2026/reyanshi-dejuan-website.webp";
// import "/src/assets/spring-sessions-2026/charlotte-daniella-audio-player.webp";
// import "/src/assets/spring-sessions-2026/righteous-science-fair.webp";
// import "/src/assets/spring-sessions-2026/jade-ann-history-website.webp";

// ** LOPL Logo ** //
// import "/src/assets/sponsor-logos/LOPL/lopl-full-round-logo-2026.png";

// ** Merrill Logo ** //
// import "/src/assets/sponsor-logos/merrill-bank-of-america.png";


// *********************** JS - Play Audio Tracks *********************** //

document.addEventListener('DOMContentLoaded', () => {
  const audio = document.getElementById('audioPlayer');
  const buttons = document.querySelectorAll('.song-btn');

  function clearAllPlaylistIcons() {
    buttons.forEach(btn => {
      // Simply strip the playing class. The CSS stylesheet takes care of the rest!
      btn.classList.remove('is-playing');
    });
  }

  buttons.forEach(button => {
    button.addEventListener('click', () => {
      const targetSongSource = button.getAttribute('data-src');

      if (audio.src && audio.src.includes(targetSongSource)) {
        if (audio.paused) {
          audio.play();
          button.classList.add('is-playing');
        } else {
          audio.pause();
          button.classList.remove('is-playing');
        }
      } else {
        clearAllPlaylistIcons();
        audio.src = targetSongSource;
        audio.play();
        button.classList.add('is-playing');
      }
    });
  });

  audio.addEventListener('ended', () => {
    clearAllPlaylistIcons();
  });
});
